import { gql } from "@apollo/client";

export const validateIbanQuery = gql`
    query validateIban($iban: String!) {
        validateIban(iban: $iban)
    }
`;
